import { useRef, useState } from "react"
import { setFlashMessage, API_ROUTES, userIsLogged } from "../../helpers"

import $ from 'jquery'
import House from "./House"

class HouseVRManager {


    vrControl(deviceName, order) {
        let operationName
        if (order.startsWith('ALL_')) {
            operationName = 'SCN_' + order
        } else {
            operationName = 'VR_' + order
        }
        const deviceLabel = deviceName ? this._VRData[deviceName].label : ''
        $.post(API_ROUTES.VR_OPERATION, {
            deviceName: deviceName,
            operation: operationName,
        }, () => {
            let flashMessage
            if (operationName === 'VR_UP') {
                flashMessage = deviceLabel + ' : volet s\'ouvre'
            } else if (operationName.startsWith('VR_POS-')) {
                if (operationName === 'VR_POS-C0') {
                    flashMessage = deviceLabel + ' : se met en position fermé - trous ouverts'
                } else {
                    const position = operationName.split('-')[1]
                    flashMessage = deviceLabel + ' : se met en position ouvert à ' + position + ' %'
                }
            } else if (operationName === 'VR_DOWN') {
                flashMessage = deviceLabel + ' : volet descend'
            } else if (operationName === 'VR_STOP') {
                flashMessage = deviceLabel + ' : volet s\'arrête'
            } else if (operationName === 'VR_PREF') {
                flashMessage = deviceLabel + ' : volet se met en position préférentielle'
            } else if (operationName === 'SCN_ALL_UP') {
                flashMessage = "Tous les volets roulants s'ouvrent"
            } else if (operationName === 'SCN_ALL_DOWN') {
                flashMessage = "Tous les volets roulants se ferment"
            }
            setFlashMessage('success', flashMessage)
        }
        ).fail(error => {
            let msg = 'Echec du changement de statut (Volet roulant ' + deviceLabel + ')';
            if (error.responseJSON && error.responseJSON.output) {
                msg += ' : ' + error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        }).always(() => {
            setTimeout(this.loadVRDataIntoTemplate.bind(this), 1000)
        })
    }

    loadVRDataIntoTemplate() {
        this.loadVRData().then((data) => {
            if (data) {
                if (JSON.stringify(this._VRData) === JSON.stringify(data)) {
                    return
                }
                this._setVRData(data)
            }
        })
    }

    getVRBoxesToDisplay() {
        if (this._VRData) {
            return Object.keys(this._VRData).map((vrName) => {
                let currentItem = this._VRData[vrName]
                let currentItemState = currentItem.state

                if (currentItem.state === 'OUVERT' && currentItem.position < 100) {
                    currentItemState += ' (' + currentItem.position + ' %)'
                }
                return (<>
                    <div className={"m-1 col-5 col-md-2 deviceBox " + (currentItem.state === 'OUVERT' ? 'deviceBox-active' : '')} key={vrName}>
                        <h6>{currentItem.label}</h6>
                        <i>{currentItemState}</i><br />
                        <i className="fa fa-arrow-circle-up m-1 cursor-pointer" onClick={() => this.vrControl(vrName, 'UP')}></i>
                        <i className="fa fa-stop-circle m-1 cursor-pointer" onClick={() => this.vrControl(vrName, 'STOP')}></i>
                        <i className="m-2 fa fa-arrow-circle-down cursor-pointer" onClick={() => this.vrControl(vrName, 'DOWN')}></i>
                        <br /><i className="fa fa-bars cursor-pointer" onClick={() => this.vrControl(vrName, 'POS-C0')}></i>
                        <button className="btn btn-light btn-sm ml-1 cursor-pointer" onClick={() => this.vrControl(vrName, 'POS-7')}>7%</button>
                        <button className="btn btn-light btn-sm ml-1 cursor-pointer" onClick={() => this.vrControl(vrName, 'POS-30')}>30%</button>
                    </div>
                </>)
            })
        }
    }

    async loadVRData() {
        return new Promise((resolve, reject) => {
            let url = API_ROUTES.VR_DATA
            $.get(url, (data) => {
                resolve(data)
            }).fail(error => {
                let msg = 'Echec du chargement des données volets roulants';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' : ' + error.responseJSON.output;
                }
                setFlashMessage('error', msg);
                resolve(data)
            }).always(() => {
            })
        })
    }

    vrControlSalon(order) {
        this.vrControl('VR_SALON_C.BOIS', order);
        this.vrControl('VR_SALON_C.TERR', order);
        this.vrControl('VR_CUISINE', order);
        this.vrControl('VR_BUREAU', order);
    }

    vrControlNightPart(order) {
        this.vrControl('VR_CH_BUREAU', order);
        this.vrControl('VR_CH_LUCIE', order);
        this.vrControl('VR_CHAMBRE', order);
    }

    vrControlAll(order) {
        this.vrControl(null, 'ALL_' + order)
    }

}

export default function HouseVR() {

    const [isLogged, setIsLogged] = useState(false)
    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                window.location.href = process.env.REACT_APP_HOST + '/common/login'
            }
            setIsLogged(isLogged)
        })
    }


    const REFRESH_INTERVAL = 30 * 1000
    let refRefreshIntervalId = useRef(null)

    const manager = new HouseVRManager()
    const [showShortcuts, setShowShortcuts] = useState(false)
    const [VRData, setVRData] = useState(null)

    manager._VRData = VRData
    manager._setVRData = setVRData

    if (VRData === null) {
        manager.loadVRDataIntoTemplate()
    }

    if (refRefreshIntervalId?.current === null) {
        refRefreshIntervalId.current = setInterval(() => {
            manager.loadVRDataIntoTemplate()
        }, REFRESH_INTERVAL)
    }


    if (isLogged) {
        return (
            <>
                <House activeTab="vr" />
                <div className="conteneur">
                    <div id="flashMessages"></div>
                    <div id="vrPart" className="text-center">
                        <h4>Volets roulants</h4>
                        <br />
                        <div className="row m-auto border-raded-5 shortcuts">
                            <h5 className="col-12 m-2" onClick={() => setShowShortcuts(!showShortcuts)}>Raccourcis
                                <i className="float-right fa fa-chevron-down"></i></h5>
                            <div className={"col-12 mb-2 shortcuts-content " + (showShortcuts !== true ? 'd-none' : '')}>
                                <button className="btn m-2 col-5 col-md-2" onClick={() => manager.vrControlAll('UP')}>
                                    <i className="fa fa-arrow-circle-up"></i> Tout ouvrir
                                </button>
                                <button className="btn m-2 col-5 col-md-2" onClick={() => manager.vrControlAll('DOWN')}>
                                    <i className="fa fa-arrow-circle-down"></i> Tout
                                    fermer
                                </button>
                                <button className="btn m-2 col-5 col-md-2" onClick={() => manager.vrControlSalon('UP')}><i
                                    className="fa fa-arrow-circle-up"></i>
                                    <i className="fa fa-home"></i> Ouvrir Esp.Vie
                                </button>

                                <button className="btn m-2  col-5 col-md-2" onClick={() => manager.vrControlSalon('DOWN')}><i
                                    className="fa fa-arrow-circle-down"></i>
                                    <i className="fa fa-home"></i> Fermer Esp.Vie
                                </button>
                                <button className="btn m-2 col-5 col-md-2" onClick={() => manager.vrControlNightPart('UP')}><i
                                    className="fa fa-arrow-circle-up"></i>
                                    <i className="fa fa-moon"></i> Ouvrir Esp.Nuit
                                </button>

                                <button className="btn m-2  col-5 col-md-2" onClick={() => manager.vrControlNightPart('DOWN')}>
                                    <i
                                        className="fa fa-arrow-circle-down"></i>
                                    <i className="fa fa-moon"></i> Fermer Esp.Nuit
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row my-2 mx-1" id="deviceVrBoxes">
                        {manager.getVRBoxesToDisplay()}
                    </div>

                    <div className="text-center small">
                        <img onClick={() => { manager.loadVRDataIntoTemplate() }} src={require('../../resources/img/refresh.png')} className="cursor-pointer"
                            style={{ width: "24px" }} alt="Forcer à rafraichir" />
                    </div>
                </div >


            </>)
    }
}
